import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AppContent from './AppContent';
import { CartProvider } from './context/CartContext';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CartProvider>
        <AppContent />
      </CartProvider>
    </BrowserRouter>
  );
}